<template>
  <AppPanelShell
    storage-key="aradcore-admin"
    brand-subtitle="پنل مدیریت"
    brand-icon="i-lucide-shield"
    :nav-items="navItems"
    :search-groups="searchGroups"
    :breadcrumbs="breadcrumbs"
    :tab-bar-items="tabBarItems"
  >
    <template #user-menu="{ collapsed }">
      <AdminUserMenu :collapsed="collapsed" />
    </template>
    <template #navbar-actions>
      <UButton
        color="neutral"
        variant="outline"
        size="sm"
        icon="i-lucide-external-link"
        class="hidden shrink-0 whitespace-nowrap md:inline-flex"
        to="/"
        target="_blank"
      >
        مشاهده سایت
      </UButton>
      <UButton
        color="error"
        variant="outline"
        size="sm"
        icon="i-lucide-log-out"
        class="hidden shrink-0 whitespace-nowrap sm:inline-flex"
        @click="logout"
      >
        خروج
      </UButton>
    </template>
    <slot />
  </AppPanelShell>
</template>

<script setup lang="ts">
import AdminUserMenu from '~/components/admin/UserMenu.vue'

const { navItems, searchGroups, breadcrumbs } = useAdminNav()
const adminStore = useAdminStore()

const tabBarItems = [
  { label: 'نمای کلی', icon: 'i-lucide-layout-dashboard', to: '/admin' },
  { label: 'کاربران', icon: 'i-lucide-users', to: '/admin/users' },
  { label: 'سایت‌ها', icon: 'i-lucide-globe', to: '/admin/sites' },
  { label: 'تیکت‌ها', icon: 'i-lucide-life-buoy', to: '/admin/tickets' },
]

async function logout() {
  await adminStore.logout()
  await navigateTo('/auth/login')
}
</script>
